<script>
    import Spinner from '~/components/Spinner.svelte';
    import { auth } from '~/firebase';
    import { onMount } from 'svelte';

    onMount(() => {
        auth.signInWithProvider('google.com');
    });
</script>

<Spinner />
